import React, { lazy } from 'react';
import styles from '../../../gen2_widgets/base/CommonSettings.module.scss';
import withSuspense from '../../../../../helpers/withSuspense.jsx';
import TooltipWithRef from '../../../../common/Tooltip.jsx';
const ExcludeSettingToggle = withSuspense(lazy(() => import('../../common/ExcludeSettingToggle.jsx')), null);

const TooltipWrapper = ({ showDescriptionTooltip, title, children }) => {
  if (!showDescriptionTooltip) return children;

  return (
    <TooltipWithRef title={title} trigger='hover'>
      {children}
    </TooltipWithRef>
  )
}

function CommonField ({ label, attr, descPrefix = '', children, col = false, className = '', required = false, hideDescription = false, excludeable = false, showDescriptionTooltip = false, style  = {},  ...rest }) {
  const key = (descPrefix + (attr || '')).replace(/\[[^\]]*\]/g, '').replace(/\./g, '_').replace(/([A-Z])/g, '_$1').toLowerCase();
  const description = I18n.t(`${key}_description`);
  return (
    <div className={`${col ? styles['settings-col-option'] : styles['settings-option']} ${className}`} style={style}>
      <label>{label}{required ? ' *' : ''}</label> {excludeable && <ExcludeSettingToggle attr={attr} {...rest}/>}
      {children}
      {attr && !hideDescription &&
        <TooltipWrapper showDescriptionTooltip={showDescriptionTooltip} title={description}>
          <p className='description text-truncate'>{description}</p>  
        </TooltipWrapper>
      }
    </div>
  )
}

export default CommonField;